var map = {
	"../menu/menu.module.ngfactory": [
		"./src/app/shared-layout/menu/menu.module.ngfactory.js",
		"menu.module"
	],
	"../restrito/instituicao/instituicao.module.ngfactory": [
		"./src/app/restrito/instituicao/instituicao.module.ngfactory.js",
		"common",
		"instituicao.module"
	],
	"./cidadao/cidadao.module.ngfactory": [
		"./src/app/publico/cidadao/cidadao.module.ngfactory.js",
		"common",
		"cidadao.module"
	],
	"./conheca-programa/conheca-programa.module.ngfactory": [
		"./src/app/publico/conheca-programa/conheca-programa.module.ngfactory.js",
		"conheca-programa.module",
		"common"
	],
	"./consumidor/consumidor.module.ngfactory": [
		"./src/app/restrito/consumidor/consumidor.module.ngfactory.js",
		"consumidor.module"
	],
	"./contato/contato.module.ngfactory": [
		"./src/app/publico/contato/contato.module.ngfactory.js",
		"common",
		"contato.module"
	],
	"./empresa/empresa.module.ngfactory": [
		"./src/app/publico/empresa/empresa.module.ngfactory.js",
		"common",
		"empresa.module"
	],
	"./inicio/inicio.module.ngfactory": [
		"./src/app/publico/inicio/inicio.module.ngfactory.js",
		"common",
		"inicio.module"
	],
	"./listagem-instituicao/listagem-instituicao.module.ngfactory": [
		"./src/app/publico/listagem-instituicao/listagem-instituicao.module.ngfactory.js",
		"listagem-instituicao.module"
	],
	"./noticias/noticias.module.ngfactory": [
		"./src/app/publico/noticias/noticias.module.ngfactory.js",
		"common",
		"noticias.module"
	],
	"./publico/publico.module.ngfactory": [
		"./src/app/publico/publico.module.ngfactory.js",
		"publico.module"
	],
	"./restrito/restrito.module.ngfactory": [
		"./src/app/restrito/restrito.module.ngfactory.js",
		"restrito.module"
	],
	"./shared-layout/notfound/notfound.module.ngfactory": [
		"./src/app/shared-layout/notfound/notfound.module.ngfactory.js",
		"notfound.module"
	],
	"./sorteios/sorteios.module.ngfactory": [
		"./src/app/publico/sorteios/sorteios.module.ngfactory.js",
		"common",
		"sorteios.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main